import { datadogRum } from '@datadog/browser-rum';

export function sendErrorReport(error: Error): void {
    datadogRum.addError(error);
}
